import React from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import QualityManual_Form from "./qualityManual_Form/QualityManual_Form";
import QualityManual_table from "./qualityManual_table/QualityManual_table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";

function QualityManual() {
  return (
    <>
      <section className="Imperiality Quality_Policy ScopeOfTheLaboratory">
        <div className="back_div">
          <Common_Back_Btn backText="Quality Manual" />
        </div>
        <div className="white_container customer_section">
          {/* Note text */}
          <div className="note_text_holder">
            <p>
              The Quality Manual defines the laboratory’s quality management
              system, outlining policies, objectives, procedures, and
              responsibilities to ensure consistent service quality. It serves
              as a reference for maintaining compliance with standards, ensuring
              accuracy in testing, and promoting continual improvement in all
              laboratory operations.
            </p>
          </div>
        </div>

        <div className="imperiality_Form_div">
          <QualityManual_Form />
        </div>

        <div className="imperiality_table_div">
          <QualityManual_table />
        </div>

        <div className="m-3">
          <div className="add_another_holder">
            <div>
              <span>
                <FontAwesomeIcon icon={faCirclePlus} /> Add Another Document
              </span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default QualityManual;
